import { memo } from "react";
import GaugeChart from "react-gauge-chart";

function Gauge({ percent = 0 }) {
  return (
    <GaugeChart
      id="dashboard-load-gauge"
      nrOfLevels={6}
      percent={percent}
      hideText
      animate={false}
    />
  );
}

export default memo(Gauge);
